import Cookies from 'js-cookie'

const TokenKey = 'fm-Token'
const RefreshKey = 'Refresh-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(RefreshKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshKey, token)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshKey)
}

export function setBusinessKYC(flag) {
  return Cookies.set('BusinessKYC', flag, 180)
}
export function setPersonalKYC(flag) {
  return Cookies.set('PersonalKYC', flag, 180)
}
export function getBusinessKYC() {
  return Cookies.get('BusinessKYC')
}
export function getPersonalKYC() {
  return Cookies.get('PersonalKYC')
}
export function getChainId() {
  return Cookies.get('TREASURE_CHAINID')
}

export function setChainId(data) {
  return Cookies.set('TREASURE_CHAINID', data)
}
